import {
  ADMIN_ROLES,
  ADVISOR_ROLES,
  CATALOGUE_ROLES,
  holdsAny,
  PROJECT_SCOPED_ROLES,
} from './user-roles'

/** Who reads each area of the staff dashboard: the route serving it admits
 *  these roles, and the tab is offered to them. */
export const STAFF_DASHBOARD_AREAS = {
  sales: ADVISOR_ROLES,
  // The roles that run a project, and the administration, which opens every
  // area. It overlaps `sales`, which carries the same project table beside the
  // customer half — an admin gets both, because an area they may not open is
  // one they cannot look at: assuming a role changes the screen, not the token
  // the request carries.
  projects: [
    ...PROJECT_SCOPED_ROLES.filter(role => !holdsAny([role], ADVISOR_ROLES)),
    ...ADMIN_ROLES,
  ],
  catalogue: CATALOGUE_ROLES,
  system: ADMIN_ROLES,
} as const

/** How far back the dashboards look for recent activity. */
export const ACTIVITY_WINDOW_DAYS = 7

/** How long a customer of an active project may be silent before the sales
 *  dashboard names the project. */
export const QUIET_CUSTOMER_DAYS = 14
